import React from 'react';

type PartnerInfoHeaderProps = {
  count: number;
  onlineRidersCount: number;
};

const PartnerInfoHeader = ({ count, onlineRidersCount }: PartnerInfoHeaderProps) => {
  return (
    <div>
      <div className='flex flex-wrap justify-start gap-3 pb-2 items-center'>
        <p className='font-medium text-xl md:text-2xl'>Riders({count})</p>
        <div className='flex justify-center py-1 text-[#73D260] bg-[#F1FAEF] border border-[#73D260] rounded-full w-24'>
          <p> {onlineRidersCount} online </p>
        </div>
      </div>
    </div>
  );
};

export default PartnerInfoHeader;
